import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import whoWe from '../images/who-we.jpg';
import icon from '../images/icon.png';
import bosco from '../images/ivan-bosco.jpg';

const WhoAreWe = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <div className="bg-grey">
          <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414]">Салезіянська харизма</h1>
        </div>
        <div className="text-justify hyphens-auto" id="section2">

          <div className="pt-3 pb-3">
            Згромадження отців Салезіян було засноване у 1859 році святим Іваном Боско в місті Турин (Італія).
            «Бути в Церкві та в суспільстві знаками й носіями Божої любові до дітей і молоді, особливо до найбідніших і найбільш потребуючих, для яких ми є євангелізаторами та вихователями згідно із задумом нашого засновника святого Івана Боско. Це є спосіб нашого служіння Господеві та Його Церкві і шлях нашого освячення».          </div>
          <div className="pt-3 pb-3">
            Згромадження є міжнародним, бере свою назву від святого Франциска Сальського й сьогодні налічує понад 15 000 богопосвячених чоловіків, які здійснюють свою діяльність у 133 країнах світу.          </div>
          <div className="pt-3 pb-3">
            Основним своїм завданням салезіяни вважають всебічний розвиток молодої людини на основі християнської католицької віри.          </div>
          <div className="pt-3 pb-3">
            У виховному процесі вони спираються на досвід отця Боско, який назвав свою методику «превентивною системою виховання». Її суть полягає в тому, щоб запобігти помилкам і гріхам, створюючи атмосферу доброго родинного духу, підбадьорюючи, підказуючи правильний шлях і супроводжуючи молоду людину в її зростанні.          </div>
          <div className="pt-3 pb-3">
            Надихаючись прикладом свого святого засновника, салезіяни впроваджують у праці з молоддю різні ініціативи: музику, спів, танці, гуртки, ігри, спорт, туристичні походи та багато іншого. Усе це — щоб молодь могла розвивати таланти, змістовно проводити час і, перебуваючи в здоровому середовищі, зростати в єдності з Господом.          </div>
        </div>
      </div>
    </>
  );
};

export default WhoAreWe;
